import * as yup from 'yup';

export const commonBankerValidation: { [x: string]: any; } = {
    bankCode: yup.string().required("Missing."),
    bankName: yup.string().required("Missing."),
    bankAcNo: yup.string().required("Missing.").length(24, "BANK A/C No.should be 24 digits."),
    bankAcCurrency: yup.string().required("Missing.").length(3, "BANK A/C Currency should be 3 digits."),
    bankAddressLine1: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createBankerValidation: { [x: string]: any; } = {
    ...commonBankerValidation,
};

export const createBankerValidationSchema = yup.object().shape(createBankerValidation);

